import React from "react";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ErrorModal({
    open,
    onClose,
    title = "Connection issues",
    message = "Please check your internet connection and try again.",
    actionLabel = "Return",
    onAction,
}) {
    const handleAction = () => {
        if (onAction) return onAction();
        onClose?.();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "grid",
                    placeItems: "center",
                    p: 2,
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: { xs: "95vw", sm: "80vw", md: "60vw" },
                        height: { xs: "70vh", sm: "60vh", md: "55vh" },
                        maxWidth: 1000,
                        bgcolor: "#000",
                        borderRadius: 4,
                        border: "1px solid rgba(255,255,255,0.7)",
                        color: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        px: 4,
                    }}
                >
                    {/* X top-right */}
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            width: 44,
                            height: 44,
                            border: "1px solid rgba(255,255,255,0.7)",
                            color: "#fff",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Icono rojo */}
                    <Box
                        sx={{
                            width: 120,
                            height: 120,
                            borderRadius: "50%",
                            border: "1.5px solid rgba(239,68,68,0.9)", // rojo
                            display: "grid",
                            placeItems: "center",
                            mb: 3,
                        }}
                    >
                        {/* X roja */}
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                position: "relative",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    margin: "auto",
                                    width: "100%",
                                    height: "2px",
                                    bgcolor: "rgba(239,68,68,0.9)",
                                    transform: "rotate(45deg)",
                                }}
                            />
                            <Box
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    margin: "auto",
                                    width: "100%",
                                    height: "2px",
                                    bgcolor: "rgba(239,68,68,0.9)",
                                    transform: "rotate(-45deg)",
                                }}
                            />
                        </Box>
                    </Box>

                    {/* Título */}
                    <Typography sx={{ fontSize: 34, mb: 1 }}>
                        {title}
                    </Typography>

                    {/* Mensaje */}
                    <Typography
                        sx={{
                            maxWidth: 520,
                            opacity: 0.8,
                            mb: 4,
                            fontSize: 16,
                            lineHeight: 1.6,
                            whiteSpace: "pre-line",
                        }}
                    >
                        {message}
                    </Typography>

                    {/* Botón */}
                    <Button
                        variant="outlined"
                        onClick={handleAction}
                        sx={{
                            borderRadius: "999px",
                            px: 6,
                            py: 1.3,
                            fontSize: 16,
                            textTransform: "none",
                            color: "#fff",
                            borderColor: "rgba(255,255,255,0.7)",
                            "&:hover": {
                                borderColor: "#fff",
                                background: "rgba(255,255,255,0.05)",
                            },
                        }}
                    >
                        Return
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}